<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3 class="info-title">品读文化（图书销售）</h3>
				</div>
				<div class="info-content" v-html="infoText"></div>
			</div>
		</div>
	</el-main>
</template>

<script>
export default {
	data() {
		return {
			infoText: `<h2>北京品读文化发展有限公司</h2><p>北京品读文化发展有限公司作为全国锅炉压力容器标准化技术委员会（SAC/TC262）法规标准图书指定服务窗口，深耕特种设备领域十余年，已发展为特种设备合规服务领域的骨干力量。</p><p></p><p>公司依托全国锅炉压力容器标准化技术委员会的标准制定核心优势，围绕特种设备行业高风险、高专业的特性，以正版法规标准为支撑，打造一站式合规解决方案，全面匹配行业全产业链需求。服务网络覆盖行业各关键环节，为各类用户提供专业高效的合规支持，助力行业安全稳健发展。</p><p></p><p>公司是特种设备法规图书的官方授权销售主体，已获得TSG（特种设备安全技术规范）、NB（能源行业）及HG（化工工程建设）等标准的独家销售授权，并与中国标准出版社、新华出版社、北京科学技术出版社等多家权威出版社建立战略合作，确保用户能够一站式获取全面、正版、及时的标准资源。</p><p></p><p>"特规通"作为公司的线上服务平台，由量大（北京）信息科技研究院有限公司提供技术支持，专注于提供正版、权威的特种设备标准图书与合规服务。</p><h3>核心资源与服务</h3><ul><li style="text-align: left;">规范标准全面覆盖 提供TSG、GB（国标）、NB、JB（机械）、HG、SH（石化）、DL（电力）及相关团体标准等全品类规范文本，贯穿设计、制造、检验检测、维保及监督检查等全生命周期环节。</li><li style="text-align: left;">精品专业书籍支持 推出《压力容器设计工程师培训教程》《特种设备安全技术（承压类、机电类）》等系列专业书籍，体系化助力从业人员能力提升。</li><li style="text-align: left;">正版保障与可追溯服务 与各大出版社紧密协作，严厉打击盗版，屡获"年度优选合作单位"称号。所有图书均官方直供，开具标准增值税电子发票，确保来源可追溯，为企业合规经营提供可靠保障。<br></li></ul><p></p>`
		};
	}
};
</script>

<style lang="less" scoped>
.info-wrap {
	margin-left: 20px;
	padding: 20px 0 !important;
	font-size: 14px;
	color: #475569;
	line-height: 1.8;
	background-color: #fff;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
	border-radius: 12px;
	 min-height: calc(100vh - 120px);

	.info-title {
		margin: 0 0 10px;
		font-weight: 600;
		font-size: 24px;
		color: #334155;
	}
}

.info-item {
	margin-bottom: 20px;
}

.info-head {
	margin-bottom: 25px;
	padding-bottom: 15px;
	border-bottom: 1px dashed #e2e8f0;

	.topbox {
		color: #94a3b8;

		dd {
			margin: 0 30px 0 0;
		}
	}
}
</style>

<style lang="less">
.info-content {
		padding: 0 30px;
	}

	.info-content h2 {
		margin: -4px 0 0 !important;
	}


	.info-content ul {
		li {
			line-height: 30px !important;
		}
	}

	.info-content p {
		margin-top: 6px !important;
		margin-bottom: 6px !important;
		line-height: 24px !important;
	}

	.info-content h3 {
		margin: 16px 0 6px !important;
	}

	.info-content h5 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}

	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #155dfc;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}
	.info-content li::marker {
		color: #1456f0;
	}
</style>